/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ooL7EhXDmFQWnW9sxtchhE
// Component: vM6JbvCArA

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  PlasmicLink as PlasmicLink__,
  renderPlasmicSlot,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import TeamPickerItem from "../../components/modals/TeamPickerItem"; // plasmic-import: 3naiwkyPoFj/component
import Button from "../../components/widgets/Button"; // plasmic-import: SEF-sRmSoqV5c/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_dashboard.css"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectcss
import sty from "./PlasmicTeamPicker.module.css"; // plasmic-import: vM6JbvCArA/css

import ArrowRightSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ArrowRightSvg"; // plasmic-import: 9Jv8jb253/icon
import ChevronDownSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: xZrB9_0ir/icon

createPlasmicElementProxy;

export type PlasmicTeamPicker__VariantMembers = {
  noTeams: "noTeams";
};
export type PlasmicTeamPicker__VariantsArgs = {
  noTeams?: SingleBooleanChoiceArg<"noTeams">;
};
type VariantPropType = keyof PlasmicTeamPicker__VariantsArgs;
export const PlasmicTeamPicker__VariantProps = new Array<VariantPropType>(
  "noTeams"
);

export type PlasmicTeamPicker__ArgsType = { children?: React.ReactNode };
type ArgPropType = keyof PlasmicTeamPicker__ArgsType;
export const PlasmicTeamPicker__ArgProps = new Array<ArgPropType>("children");

export type PlasmicTeamPicker__OverridesType = {
  root?: Flex__<"div">;
  link?: Flex__<"a">;
  newTeamName?: Flex__<"input">;
  createTeamButton?: Flex__<typeof Button>;
};

export interface DefaultTeamPickerProps {
  children?: React.ReactNode;
  noTeams?: SingleBooleanChoiceArg<"noTeams">;
  className?: string;
}

const $$ = {};

function PlasmicTeamPicker__RenderFunc(props: {
  variants: PlasmicTeamPicker__VariantsArgs;
  args: PlasmicTeamPicker__ArgsType;
  overrides: PlasmicTeamPicker__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "noTeams",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.noTeams,
      },
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_ooL7EhXDmFQWnW9sxtchhE",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div className={classNames("all", sty.freeBox__yFvIw)}>
        <div className={classNames("all", "__wab_text", sty.text__bCkKu)}>
          {"Select an organization to upgrade"}
        </div>
        <div className={classNames("all", "__wab_text", sty.text__ietak)}>
          {"Upgrade account to unlock more features."}
        </div>
        <PlasmicLink__
          data-plasmic-name={"link"}
          data-plasmic-override={overrides.link}
          className={classNames("all", "a", "a__ooL7E", "__wab_text", sty.link)}
          href={"https://www.plasmic.app/pricing"}
          platform={"react"}
          target={"_blank"}
        >
          {"Learn more."}
        </PlasmicLink__>
      </div>
      <div
        className={classNames("all", sty.freeBox__zbduW, {
          [sty.freeBoxnoTeams__zbduWHye8O]: hasVariant(
            $state,
            "noTeams",
            "noTeams"
          ),
        })}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <React.Fragment>
              <TeamPickerItem
                className={classNames(
                  "__wab_instance",
                  sty.teamPickerItem__tbmcx
                )}
              />

              <TeamPickerItem
                className={classNames(
                  "__wab_instance",
                  sty.teamPickerItem__pDvMy
                )}
              />

              <TeamPickerItem
                className={classNames(
                  "__wab_instance",
                  sty.teamPickerItem__at80Z
                )}
              />
            </React.Fragment>
          ),
          value: args.children,
        })}
      </div>
      <div
        className={classNames("all", sty.freeBox__bnwG, {
          [sty.freeBoxnoTeams__bnwGHye8O]: hasVariant(
            $state,
            "noTeams",
            "noTeams"
          ),
        })}
      >
        <div className={classNames("all", sty.freeBox__jAxOg)} />

        <div className={classNames("all", "__wab_text", sty.text__flC2V)}>
          {"or"}
        </div>
        <div className={classNames("all", sty.freeBox__tAsEk)} />
      </div>
      <div className={classNames("all", sty.freeBox__zdy3R)}>
        <div
          className={classNames("all", sty.freeBox__xNslH, {
            [sty.freeBoxnoTeams__xNslHHye8O]: hasVariant(
              $state,
              "noTeams",
              "noTeams"
            ),
          })}
        >
          <input
            data-plasmic-name={"newTeamName"}
            data-plasmic-override={overrides.newTeamName}
            className={classNames(
              "all",
              "input",
              "input__ooL7E",
              sty.newTeamName,
              {
                [sty.newTeamNamenoTeams]: hasVariant(
                  $state,
                  "noTeams",
                  "noTeams"
                ),
              }
            )}
            placeholder={"Enter organization name\u2026"}
            ref={(ref) => {
              $refs["newTeamName"] = ref;
            }}
            size={1}
            type={"text"}
            value={""}
          />
        </div>
        <Button
          data-plasmic-name={"createTeamButton"}
          data-plasmic-override={overrides.createTeamButton}
          className={classNames("__wab_instance", sty.createTeamButton, {
            [sty.createTeamButtonnoTeams]: hasVariant(
              $state,
              "noTeams",
              "noTeams"
            ),
          })}
          endIcon={
            <ChevronDownSvgIcon
              className={classNames("all", sty.svg__pg7L2)}
              role={"img"}
            />
          }
          size={"wide"}
          startIcon={
            <ArrowRightSvgIcon
              className={classNames("all", sty.svg__huEL)}
              role={"img"}
            />
          }
          type={["primary"]}
        >
          {"Create new organization"}
        </Button>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "link", "newTeamName", "createTeamButton"],
  link: ["link"],
  newTeamName: ["newTeamName"],
  createTeamButton: ["createTeamButton"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  link: "a";
  newTeamName: "input";
  createTeamButton: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTeamPicker__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTeamPicker__VariantsArgs;
    args?: PlasmicTeamPicker__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicTeamPicker__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicTeamPicker__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTeamPicker__ArgProps,
          internalVariantPropNames: PlasmicTeamPicker__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicTeamPicker__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTeamPicker";
  } else {
    func.displayName = `PlasmicTeamPicker.${nodeName}`;
  }
  return func;
}

export const PlasmicTeamPicker = Object.assign(
  // Top-level PlasmicTeamPicker renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    link: makeNodeComponent("link"),
    newTeamName: makeNodeComponent("newTeamName"),
    createTeamButton: makeNodeComponent("createTeamButton"),

    // Metadata about props expected for PlasmicTeamPicker
    internalVariantProps: PlasmicTeamPicker__VariantProps,
    internalArgProps: PlasmicTeamPicker__ArgProps,
  }
);

export default PlasmicTeamPicker;
/* prettier-ignore-end */
